import React, { useState, useEffect } from 'react';
// 单个日期格子的最大宽度百分比
const SINGLE_CELL_MAX_WIDTH = 100;
// 日历内容区域默认高度
const SINGLE_CELL_MAX_HEIGHT = 574;
// 日历子格子默认显示数量
const DEFAULT_MAX_COUNT_ITEM = 3;
// 宽度伸缩阈值
const WIDTH_THRESHOLD = 900;
// 高度伸缩阈值
const HEIGHT_THRESHOLD = 700;
// 六行七列布局的行数
const ROW_COUNT = 6;
// 每行高度
const ROW_HEIGHT_ITEM = 17;
// 剩余区域高度
const ROW_OTHER_HEIGHT_ITEM = 40;

/* 
 日历尺寸自适应
*/
export const useResizeCalendar = () => {
  const [width, setWidth] = useState<number>(SINGLE_CELL_MAX_WIDTH);
  const [height, setHeight] = useState<number>(SINGLE_CELL_MAX_HEIGHT);
  const [maxCountItem, setmaxCountItem] = useState(DEFAULT_MAX_COUNT_ITEM);

  const handleResizeCalendar = (event: any) => {
    const newWidth = event.currentTarget.innerWidth;
    const newHeight = event.currentTarget.innerHeight;

    if (newWidth <= WIDTH_THRESHOLD) {
      const widthChange = newWidth - WIDTH_THRESHOLD;
      setWidth((w) => {
        return Number(((WIDTH_THRESHOLD + widthChange) / WIDTH_THRESHOLD).toFixed(2)) * 100;
      });
    } else {
      setWidth(SINGLE_CELL_MAX_WIDTH);
    }
    if (newHeight >= HEIGHT_THRESHOLD) {
      const heightChange = newHeight - HEIGHT_THRESHOLD;
      setHeight(() => {
        return SINGLE_CELL_MAX_HEIGHT + heightChange;
      });
    } else {
      setHeight(SINGLE_CELL_MAX_HEIGHT);
    }
  };

  useEffect(() => {
    const singleItemHeight = height / ROW_COUNT;
    const maxCount = Number(((singleItemHeight - ROW_OTHER_HEIGHT_ITEM) / ROW_HEIGHT_ITEM).toFixed(0));
    setmaxCountItem(maxCount);
  }, [height]);

  useEffect(() => {
    const throttledHandleEvent = handleResizeCalendar;
    window.addEventListener('resize', throttledHandleEvent);
    return () => {
      window.removeEventListener('resize', throttledHandleEvent);
    };
  }, []);
  return { width, height, maxCountItem };
};
